import { Button, Select, SelectTree as SpauiSelectTree } from '@tencent/spaui';
import React, { useState, useEffect } from 'react';
import useSelect from '../../../leads_component/shared-components/hooks/useSelect';
import { RPCFactory } from '../../../utils/RequestUtil';

const FansInquire = (props) => {
  const sexHooks = useSelect({ data: [{ label: '请选择', value: null }, ...props.sexList] });
  const tagHooks = useSelect({ data: props.tags, value: [] });
  const intentionHooks = useSelect({ data: [{ label: '请选择', value: null }, ...props.leadsIntentionTags] });

  const subscribeSceneHooks = useSelect({ data: [{ label: '请选择', value: null }, ...props.subscribeScenes] });

  const campaignHooks = useSelect({ data: [], value: [] });
  const adHooks = useSelect({ data: [], value: [] });
  const subscribeStatusHooks = useSelect({ data: [{ label: '请选择', value: null }, ...props.subscribeStatusList] });

  const [regionValue, setRegionValue] = useState('');
  const [currentNode, setCurrentNode] = useState({});

  useEffect(() => {
    if (props.wxAppId != null && props.wxAppId != '') {
      RPCFactory.mpCampaign.list(props.wxAppId).done((data) => {
        campaignHooks.setData(data.entities);
      });

      RPCFactory.mpAdGroup.list(props.wxAppId).done((data) => {
        adHooks.setData(data.entities);
      });
    }
  }, [props.wxAppId]);

  useEffect(() => {
    tagHooks.setData(props.tags);
  }, [props.tags]);

  const doSearch = () => {
    const condition = {
      sex: sexHooks.props.value,
      province: currentNode.parentId ? currentNode.parentId : currentNode.value,
      city: currentNode.parentId ? currentNode.value : null,
      tagIds: tagHooks.props.value,
      intentionScore: intentionHooks.props.value,
      subscribeScene: subscribeSceneHooks.props.value,
      subscribeStatus: subscribeStatusHooks.props.value,
      adIds: adHooks.props.value,
      campaignIds: campaignHooks.props.value,
    };

    props.onSubmit(condition);
  };

  const doReset = () => {
    sexHooks.setValue(null);
    tagHooks.setValue([]);
    intentionHooks.setValue(null);
    subscribeSceneHooks.setValue(null);
    subscribeStatusHooks.setValue(null);
    adHooks.setValue([]);
    campaignHooks.setValue([]);
    setCurrentNode({});
    setRegionValue('');
  };

  return (
    <div className="inquire-area">
      <ul className="inquire-ul clearfix">
        <li className="inquire-li">
          <span className="inquire-tt">性别</span>
          <div className="inquire-con">
            <Select {...sexHooks.props} clear></Select>
          </div>
        </li>
        <li className="inquire-li">
          <span className="inquire-tt">省市</span>
          <div className="inquire-con">
            <div className="sl">
              {/* <Select data={[ { label : '请选择', value: ''}]} /> */}
              <SpauiSelectTree
                value={regionValue}
                data={props.region}
                onChange={(e, value, treeNode, valueNodeMap) => {
                  setRegionValue(value);
                  setCurrentNode({ ...treeNode });
                }}
                showParentNodeLabel={false}
                setNodeClassName={(treeNode) => `className-${treeNode.value}`}
                style={{
                  width: '270px',
                }}
                clear
              ></SpauiSelectTree>
            </div>
          </div>
        </li>
        <li className="inquire-li">
          <span className="inquire-tt">标签</span>
          <div className="inquire-con">
            <Select multiple valueFieldName="tagId" labelFieldName="tagName" {...tagHooks.props} clear />
          </div>
        </li>
        <li className="inquire-li">
          <span className="inquire-tt">意向评分</span>
          <div className="inquire-con">
            <Select {...intentionHooks.props} clear />
          </div>
        </li>
        <li className="inquire-li">
          <span className="inquire-tt">渠道来源</span>
          <div className="inquire-con">
            <Select {...subscribeSceneHooks.props} clear />
          </div>
        </li>
        <li className="inquire-li">
          <span className="inquire-tt">推广计划</span>
          <div className="inquire-con">
            <Select
              multiple
              valueFieldName="mpCampaignId"
              labelFieldName="campaignName"
              {...campaignHooks.props}
              clear
            />
          </div>
        </li>
        <li className="inquire-li">
          <span className="inquire-tt">广告</span>
          <div className="inquire-con">
            <Select multiple valueFieldName="mpAdId" labelFieldName="adName" {...adHooks.props} clear />
          </div>
        </li>
        <li className="inquire-li">
          <span className="inquire-tt">状态</span>
          <div className="inquire-con">
            <Select {...subscribeStatusHooks.props} clear />
          </div>
        </li>
      </ul>
      <div className="btn-line">
        <Button type="button" bsStyle="primary" onClick={doSearch}>
          查询
        </Button>
        <Button type="button" bsStyle="default" onClick={doReset}>
          重置
        </Button>
      </div>
    </div>
  );
};

export default FansInquire;
